function encoded(value) {
  return encodeURIComponent(value || '');
}
export default function shareTargets(data) {
  const telegramText = `${data.title}\n\n${data.description}`.trim();
  const maxText = `${data.title}\n\n${data.description}\n\n${data.url}`.trim();

  // Параметры title, description и image дополняют URL. Социальная сеть всё равно проверит
  // Open Graph страницы, поэтому эти значения совпадают с серверной мета-разметкой DevConnect.
  return [{
    key: 'vk',
    label: 'ВК',
    url: `https://vk.com/share.php?url=${encoded(data.url)}&title=${encoded(data.title)}&description=${encoded(data.description)}&image=${encoded(data.image)}`
  }, {
    key: 'ok',
    label: 'ОК',
    url: `https://connect.ok.ru/offer?url=${encoded(data.url)}&title=${encoded(data.title)}&description=${encoded(data.description)}&imageUrl=${encoded(data.image)}`
  }, {
    key: 'max',
    label: 'MAX',
    url: `https://max.ru/:share?text=${encoded(maxText)}`
  }, {
    key: 'telegram',
    label: 'Telegram',
    url: `https://t.me/share/url?url=${encoded(data.url)}&text=${encoded(telegramText)}`
  }];
}
flarum.reg.add('devconnect-articles', 'forum/service/shareTargets', shareTargets);